import React, { useEffect } from 'react';
import Typography from '@material-ui/core/Typography';
import { Trans, useTranslation } from 'react-i18next';

import { Switch } from '@material-ui/core';

import { useDispatch, useSelector } from 'react-redux';

import style from './style';

import {
  resetSyncConfigsApiResponse,
  updateSyncConfigsApi,
} from 'store/features/integration/integration.action';
import { getSyncConfigs } from 'store/features/integration/integration.selector';
import { showSnackbar } from 'helpers/common.helper';
import { openNewTab } from 'helpers/open-new-tab';
import PageDescription from 'components/page-description/page-description';

export default function FutureDatedSync(): JSX.Element {
  const classes = style();
  const { futureDatedData } = useSelector(getSyncConfigs);

  const dispatch = useDispatch();

  const { t } = useTranslation();

  const onSubmit = (checked: boolean): void => {
    if (futureDatedData === checked) {
      showSnackbar({
        message: t('DASHBOARD_DATA_SYNC_INITIAL_SAVE_TOAST_NONE'),
        type: 'success',
      });
    } else {
      dispatch(updateSyncConfigsApi({ futureDatedData: checked }));
    }
  };

  useEffect(() => {
    return () => {
      dispatch(resetSyncConfigsApiResponse());
    };
  }, []);

  return (
    <div className={classes.futureDatedSyncContainer}>
      <div className={classes.futureDatedSyncHeader}>
        <Typography variant="h3" className={classes.title}>
          {t('DASHBOARD_FUTURE_DATED_SYNC_TITLE')}
        </Typography>
        <div className={classes.futureDatedSyncToggle}>
          <Typography color={futureDatedData ? 'primary' : 'textSecondary'}>
            {futureDatedData
              ? t('DASHBOARD_FUTURE_DATED_SYNC_TOGGLED_ON')
              : t('DASHBOARD_FUTURE_DATED_SYNC_TOGGLED_OFF')}
          </Typography>
          <Switch
            checked={futureDatedData}
            inputProps={{
              'aria-label': `${t(
                futureDatedData ? 'DASHBOARD_TOGGLE_DISABLE' : 'DASHBOARD_TOGGLE_ENABLE',
              )}`,
            }}
            onChange={(_, checked): void => onSubmit(checked)}
            color="primary"
            className={classes.checkboxContainerA}
          />
        </div>
      </div>
      <PageDescription className={classes.futureDatedSyncDescription}>
        <Trans
          i18nKey="DASHBOARD_FUTURE_DATED_SYNC_DESCRIPTION"
          components={{
            a: (
              <a
                className={classes.link}
                // eslint-disable-next-line max-len
                href="https://docs.railz.ai/reference/syncing-data#on-demand-data-synchronization-using-the-dashboard"
                onClick={(e): void =>
                  openNewTab(
                    e,
                    // eslint-disable-next-line max-len
                    'https://docs.railz.ai/reference/syncing-data#on-demand-data-synchronization-using-the-dashboard',
                  )
                }
                rel="noopener noreferrer"
              >
                {t('DASHBOARD_LEARN_MORE_CTA')}
              </a>
            ),
          }}
        />
      </PageDescription>
    </div>
  );
}
